import { Component, Inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgbActiveModal, NgbProgressbarModule } from "@ng-bootstrap/ng-bootstrap";
import { DataProvider } from "../../interfaces/data-provider.interface";
import { SyncProgress } from "../../types/document.interface";
import { DATA_PROVIDER } from "../../tokens";

@Component({
	standalone: true,
	selector: 'wd-sync-progress',
	templateUrl: './sync-progress.component.html',
	imports: [CommonModule, NgbProgressbarModule]
})
export class SyncProgressComponent {
	constructor(
		public activeModal: NgbActiveModal,
		@Inject(DATA_PROVIDER) private dataProvider: DataProvider
	) {}

	get syncList(): SyncProgress[] {
		return this.dataProvider.syncProgressList();
	}

	get isSyncing(): boolean {
		return this.dataProvider.isSyncing();
	}

	get allDone(): boolean {
		return this.syncList.every(p => p.status === 'done' || p.status === 'error');
	}

	get hasErrors(): boolean {
		return this.syncList.some(p => p.status === 'error');
	}

	getStatusIcon(status: SyncProgress['status']): string {
		switch (status) {
			case 'pending': return 'bi-hourglass';
			case 'syncing': return 'bi-arrow-repeat';
			case 'done': return 'bi-check-circle-fill text-success';
			case 'error': return 'bi-x-circle-fill text-danger';
		}
	}

	getProgressType(status: SyncProgress['status']): string {
		switch (status) {
			case 'error': return 'danger';
			case 'done': return 'success';
			default: return 'primary';
		}
	}

	onClose(): void {
		this.activeModal.close(this.hasErrors ? 'error' : 'success');
	}
}
